'use client'

import { addHours } from 'date-fns'
import { useSearchParams } from 'next/navigation'
import { useEffectOnce } from 'react-use'

import { cookies } from '@/libs/cookie'

const UtmHandler: React.FC = () => {
  const searchParams = useSearchParams()

  // __EFFECT's - Handle UTM parameters
  useEffectOnce(() => {
    const utmSource = searchParams.get('utm_source')
    if (utmSource && !cookies.get('source')) {
      cookies.set('source', utmSource, {
        domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
        expires: addHours(new Date(), process.env.NEXT_PUBLIC_COOKIE_HOURS ? parseInt(process.env.NEXT_PUBLIC_COOKIE_HOURS) : 24),
        path: '/',
      })
    }

    const utmContent = searchParams.get('utm_content')
    if (utmContent && !cookies.get('utm_content')) {
      cookies.set('utm_content', Array.from(utmContent).slice(0, 10).join(''), {
        domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
        expires: addHours(new Date(), process.env.NEXT_PUBLIC_COOKIE_HOURS ? parseInt(process.env.NEXT_PUBLIC_COOKIE_HOURS) : 24),
        path: '/',
      })
    }
  })

  // This component doesn't render anything visible
  return null
}

export default UtmHandler
